export const VOICE_MIN_DB = -60;
export const VOICE_MAX_DB = 10;

// Console fader taper (audio taper, not dB-linear): most of the travel lives
// around unity — 0.33 dB per step near 0 dB, widening toward the bottom where
// precision does not matter. Piecewise-linear through desk-style anchors;
// unity sits at 80 % like on a mixing desk. (dB-linear before: the whole top
// half felt like nothing happened and the bottom half did everything.)
const taper = (minDb: number, maxDb: number): ReadonlyArray<readonly [number, number]> => [
  [0, minDb], // treated as −∞ below
  [10, -40],
  [25, -25],
  [50, -10],
  [80, 0],           // unity — keep at a slider-step-exact position
  [100, maxDb],
];

export function sliderToDb(pos: number, minDb = VOICE_MIN_DB, maxDb = VOICE_MAX_DB): number | null {
  if (pos <= 0) return null; // −∞
  const p = Math.min(100, pos);
  const TAPER = taper(minDb,maxDb);
  for (let i = 1; i < TAPER.length; i++) {
    const [p0, d0] = TAPER[i - 1]!;
    const [p1, d1] = TAPER[i]!;
    if (p <= p1) return d0 + ((p - p0) / (p1 - p0)) * (d1 - d0);
  }
  return maxDb;
}
export function dbToGain(db: number | null): number {
  return db === null ? 0 : Math.pow(10, db / 20);
}
export function gainToSlider(gain: number, minDb = VOICE_MIN_DB, maxDb = VOICE_MAX_DB): number {
  if (gain <= 0) return 0;
  const db = 20 * Math.log10(gain);
  if (db <= minDb) return 0;
  const TAPER = taper(minDb,maxDb);
  for (let i = 1; i < TAPER.length; i++) {
    const [p0, d0] = TAPER[i - 1]!;
    const [p1, d1] = TAPER[i]!;
    // No rounding: with step 0.1 the unity anchor (80) is slider-exact, so a
    // reset lands on 0.0 dB.
    if (db <= d1) return p0 + ((db - d0) / (d1 - d0)) * (p1 - p0);
  }
  return 100;
}
